import app from '../../../app';
import Home from '../../../templates/layout/Home';

import patient from './patient';
import about from './about';
import alerts from './alerts';
import settings from './settings';

import create from './patient/create.js';
import list from './patient/list';

import reports from './reports/reports.js';


/**
 * General routes
 *
 * By default redirects to Alerts screen
 * @name router.Home
 */

export default {
  path: '/',
  component: Home,
  redirect: { name: 'Alerts' },
  meta: {
    title: 'Home',
    loggedInOnly: true
  },
  children: [
    create,
    patient,
    about,
    alerts,
    settings,
    list,
    reports,
  ],
  beforeEnter(to, from, next) {
    if (app.authentication.isLoggedIn()) {
      next();
    }
    else {
      next({ name: 'Login' })
    }
  },
};

